import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
// MUI
import { AppBar, Tabs, Tab, ButtonGroup } from "@mui/material";
import PropTypes from "prop-types";
// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";
import TemplateMaster from "../template-master/TemplateMaster";
import api from "../../api/api";
import Quiz from "../quiz_template/Quiz";
import Carousel from "react-material-ui-carousel";
// Thunks
import {
  createPptContent,
  getAllProgramTypes,
  getAllTopics,
  getAllModules,
  getAllsubModules,
  updatePptContent,
  createQuizContent,
  getAllContents,
  deleteAllContents,
  getAllQuizes,
  updateAllQuiz,
  deleteQuiz,
  createLink,
  getLink,
  deleteLink,
  updateLink,
} from "./Pedagogy.Thunk";

// Thunks
import {
  // getAllProgramTypes,
  // getAllModules,
  // getAllsubModules,
  // getAllTopics,
  getAllData,
  updateassignmentquestion,
  deleteAssignmentData,
  createAssignmentData,
} from "../Pedagogy_assignment-section/PedagogyAssignment.Thunk";
// MUI
import {
  Container,
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Typography,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Paper,
  CircularProgress,
  // paper,
  // TableBody,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { purple } from "@mui/material/colors";
import { indigo } from "@mui/material/colors";
import TaskIcon from "@mui/icons-material/Task";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";
import { deleteFileFromDB } from "../../components/Azure";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

function Pedagogy() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };
  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const ITEM_HEIGHT = 48;

  // ---------------------- Section -1 Dropdowns -----------------------
  const [preferedlanguage, setPreferedlanguage] = useState("od");
  const [usertype, setUsertype] = useState("fellow");
  const [programtype, setProgramtype] = useState("");
  const [programData, setProgramData] = useState([]);
  const [modules, setModules] = useState([]);
  const [selModuleDetails, setSelModuleDetails] = useState("");
  const [subModules, setSubModules] = useState([]);
  const [selSubModuleDetails, setSelSubModuleDetails] = useState("");
  const [topics, setTopics] = useState([]);
  const [selTopicDetails, setSelTopicDetails] = useState("");
  const [quizzType, setQuizzType] = useState("");
  const [assignmentData, setAssignmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [referenceDataArray, setReferenceDataArray] = useState([]); //To store our data while saving
  const [referenceData, setReferenceData] = useState("");
  const [referenceArray, setReferenceArray] = useState([]); //To store the fetched data from API
  const [label, setLabel] = useState("");
  //&--------------------To handle video play-----------------------
  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  const trainingTypeArray =
    usertype === "cci"
      ? [
          {
            trainingType: "training1",
            trainingName: "21st Century Skills",
          },

          {
            trainingType: "training3",
            trainingName: "Pedagogy",
          },
        ]
      : [
          {
            trainingType: "training1",
            trainingName: "21st Century Skills",
          },
          {
            trainingType: "training2",
            trainingName: "Technology",
          },
          {
            trainingType: "training3",
            trainingName: "Pedagogy",
          },
        ];

  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "Anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
    { value: "cci", text: "CCI" },
  ];

  const quizType_select_option_list = [
    { value: "quiz1", text: "Quiz-1" },
    { value: "quiz2", text: "Quiz-2" },
  ];

  const handleVertMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(data);
  };

  const [selectedData, setSelectedData] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);

  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedData({});
  };

  const preflanguage_select_onchange = (e) => {
    if (!e.target.value) {
      setPreferedlanguage("");
      setUsertype("");
      setProgramtype("");
      setProgramData([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
      setContents([]);
      setReferenceArray([]);
    } else {
      setUsertype("");
      setProgramtype("");
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setReferenceArray([]);
      setPreferedlanguage(e.target.value);
    }
  };

  const usertype_select_onchange = (e) => {
    if (!e.target.value) {
      setUsertype("");

      setProgramtype("");
      setProgramData([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
      setContents([]);
      setReferenceArray([]);
    } else {
      setUsertype(e.target.value);
      setProgramtype("");
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setReferenceArray([]);
    }
  };

  const program_select_onchange = (event) => {
    //
    if (!event.target.value) {
      setProgramtype("");
      setReferenceArray([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
      setContents([]);
    } else {
      setLoading(true);
      setReferenceArray([]);
      setProgramtype(event.target.value);
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      const data = {
        trainingType: event.target.value,
        usertype: usertype,
        language: preferedlanguage,
      };

      getAllModules(data)
        .then((modules) => {
          setModules(modules.data);
          setLoading(false);
        })
        .catch((error) => {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          return false; // Prevent Swal from closing
        });
    }
  };

  const module_select_onchange = (e) => {
    if (!e.target.value) {
      setSelModuleDetails("");
      setReferenceArray([]);
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
      setContents([]);
    } else {
      setLoading(true);
      setReferenceArray([]);
      setSelModuleDetails(e.target.value);
      setSelSubModuleDetails("");
      setSelTopicDetails("");

      const data = {
        usertype: usertype,
        language: preferedlanguage,
        trainingType: programtype,
        moduleid: e.target.value,
      };
      getAllsubModules(data)
        .then((submodules) => {
          setSubModules(submodules.data);
          setLoading(false);
        })
        .catch((error) => {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          return false; // Prevent Swal from closing
        });
    }
  };

  const submodule_select_onchange = (e) => {
    if (!e.target.value) {
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setTopics([]);
      setContents([]);
      setReferenceArray([]);
    } else {
      setLoading(true);
      setReferenceArray([]);
      setSelSubModuleDetails(e.target.value);
      setSelTopicDetails("");
      setTopics([]);
      setContents([]);

      const data = {
        trainingType: programtype,
        usertype: usertype,
        language: preferedlanguage,
        moduleid: selModuleDetails,
        submoduleid: e.target.value,
      };

      getAllTopics(data)
        .then((topic) => {
          setTopics(topic.data);
          setLoading(false);
        })
        .catch((error) => {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          return false; // Prevent Swal from closing
        });
    }
  };

  const topic_select_onchange = (e) => {
    if (!e.target.value) {
      setSelTopicDetails("");
      setContents([]);
      setQuiz([]);
      setQuizType("");
      setAssignmentData([]);
      setDisable_content_button(true);
      setSelTopicDetails(""); //
      setReferenceArray([]);
    } else {
      setContents([]);
      setSelTopicDetails(e.target.value);
      setDisable_content_button(false);
      setShowQuizButton(false);
      setReferenceArray([]);
      setLoading(true);
      getAllContents({
        topicId: e.target.value.topicId,
      }).then((res) => {
        if (res.data.length > 0) {
          setContents(res.data);
        }
        setLoading(false);
        // //console.log("getAllContents------------------>", res.data);
      });
      if (e.target.value.topicId) {
        const data = {
          topicId: e.target.value.topicId,
          quizType: quizType,
        };

        if (quizType) {
          getAllQuizes(data)
            .then((res) => {
              if (res.status === 200) {
                setQuiz(res.data);
              } else if (res.status === 204) {
                setQuiz([]);
                toast.info("No quizzes available for the selected topic.");
              }
            })
            .catch((error) => {
              if (error.response.status === 500) {
                toast.error("Internal server error.");
              } else if (error.response.status === 504) {
                toast.error("Server timeout. Please try again later.");
              } else {
                console.error("An unexpected error occurred:", error);
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
              }
              return false; // Prevent Swal from closing
            });
        }

        getAllData({ topicId: e.target.value.topicId })
          .then((res) => {
            if (res.status === 200) {
              setAssignmentData(res.data);
            } else if (res.status === 204) {
              setAssignmentData([]);
              toast.info("No assignments available for the selected topic.");
            }
          })
          .catch((error) => {
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
            return false; // Prevent Swal from closing
          });
      }
      getLink({ topicId: e.target.value.topicId })
        .then((res) => {
          if (res.status === 200) {
            setReferenceArray(res.data);
          } else if (res.status === 204) {
            setReferenceArray([]);
            // toast.info("No quizzes available for the selected topic.");
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          return false; // Prevent Swal from closing
        });
    }
  };

  const handleApiError = (error) => {
    if (error.response) {
      if (error.response.status === 500) {
        toast.error("Server error. Please try again later.");
      } else if (error.response.status === 504) {
        toast.error("Gateway timeout. Please try again later.");
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } else if (error.request) {
      toast.error(
        "No response from server. Please check your network connection."
      );
    } else {
      toast.error("An error occurred. Please try again.");
    }
  };
  // -----------------------------------------------------------------

  // ---------------------- Section -2  Content ----------------------
  const [params, setParams] = useState({});

  const [contents, setContents] = useState([]); //To store the contents that will be mapped.
  //console.log("setContents----------->", contents);
  const [quiz, setQuiz] = useState([]); //To store the quizes that will be mapped

  //Function to create the data--------------------------------
  const create_content_button_click = () => {
    if (contents.length > 0)
      Swal.fire(
        "Error",
        "Could not create content. Content for this topic already exists. If you still want to create a new one, please first delete the existing one.",
        "error"
      );
    else {
      const params = {
        operation: "save",
        trainingType: programtype,
        contentdata: contents,
        preferedlanguage: preferedlanguage,
        usertype,
        moduleid: selModuleDetails,
        submoduleid: selSubModuleDetails,
        topicid: selTopicDetails.topicId,
      };
      setParams(params);
      setOpenEditor(true);
    }
  };

  const update_content_button_click = () => {
    if (contents.length <= 0)
      Swal.fire(
        "Error",
        "No content found. There is no content found to update, please select a content.",
        "warning"
      );
    else {
      const params = {
        operation: "update",
        trainingType: programtype,
        contentdata: contents,
        preferedlanguage: preferedlanguage,
        usertype,
        moduleid: selModuleDetails,
        submoduleid: selSubModuleDetails,
        topicid: selTopicDetails.topicId,
      };
      setParams(params);
      setOpenEditor(true);
    }
  };

  //Function to delete the content-------------------------------
  const delete_content_button_click = (eachsegment, index) => {
    if (contents.length <= 0)
      Swal.fire(
        "Error",
        "No content found. There is no content found to delete, please select a content.",
        "warning"
      );
    else {
      Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this record!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      })
        .then((result) => {
          if (result.isConfirmed) {
            const data = {
              topicId: selTopicDetails.topicId,
            };
            if (selTopicDetails.topicId) {
              deleteAllContents(data).then((response) => {
                if (response && response.status === 200) {
                  const data = {
                    usertype: usertype,
                    trainingType: programtype,
                    moduleid: selModuleDetails,
                    submoduleid: selSubModuleDetails,
                    topicId: selTopicDetails?.topicId,
                    language: preferedlanguage,
                  };

                  if (selTopicDetails.topicId) {
                    getAllContents(data).then((content) => {
                      setContents(content.data);
                      const data = {
                        topicId: selTopicDetails.topicId,
                        quizType: quizType,
                      };
                      if (quizType) {
                        getAllQuizes(data).then((res) => setQuiz(res.data));
                      }
                    });
                  } else {
                    setContents("");
                  }
                }
              });
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          return false; // Prevent Swal from closing
        });
    }
  };
  // -----------------------------------------------------------------

  // ---------------------- Section -3 Options -----------------------
  const navigate_to = (page) => {
    navigate(page);
  };
  // -----------------------------------------------------------------
  const [disable_content_button, setDisable_content_button] = useState(true);
  const [contentDetails, setContentDetails] = useState([]);
  const [showQuizButton, setShowQuizButton] = useState(true);

  const [quizQuestion, setQuizQuestion] = useState("");
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  const [quizAns, setQuizAns] = useState("");
  const [quizType, setQuizType] = useState("");

  const quizType_onChange = (event) => {
    setQuizType(event.target.value);
    if (event.target.value) {
      const data = {
        topicId: selTopicDetails.topicId,
        quizType: event.target.value,
      };
      getAllQuizes(data).then((res) => {
        setQuiz(res.data);
      });
    }
  };

  const quiz_question_select_onchange = (event) => {
    setQuizQuestion(event.target.value);
  };

  const quiz_optA_select_onchange = (event) => {
    setOptionA(event.target.value);
  };

  const quiz_optB_select_onchange = (event) => {
    setOptionB(event.target.value);
  };

  const quiz_optC_select_onchange = (event) => {
    setOptionC(event.target.value);
  };

  const quiz_optD_select_onchange = (event) => {
    setOptionD(event.target.value);
  };

  const quiz_ans_select_onchange = (event) => {
    setQuizAns(event.target.value);
  };

  // ----------- create, update delete button click ----------

  // -------------- Editor -----------------------

  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  const [contentduration, setContentduration] = useState(0);
  const [content, setContent] = useState("");
  const [contentid, setContentid] = useState();
  const [contenttype, setContenttype] = useState("content");
  const [index, setIndex] = useState(-1);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showCreate, setShowCreate] = useState(false);

  const handleCloseEditor = () => {
    setOpenEditor(false);
    // setPreferedlanguage("");
    // setUsertype("");
    // setProgramtype("");
    // setSelModuleDetails("");
    // setSubModules([]);
    // setSelSubModuleDetails("");
    // setTopics([]);
    // setSelTopicDetails("");
    // setContents([]);
  };

  //---------------create quiz----------------------//

  const create_quiz_button_click = () => {
    if (
      preferedlanguage &&
      usertype &&
      programtype &&
      selModuleDetails &&
      selSubModuleDetails &&
      selTopicDetails &&
      quizType
    ) {
      setShowCreate(true);
    }
  };

  const handleCloseCreate = () => {
    setShowCreate(false);
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const [questionId, setQuestionId] = useState("");

  const handleQuizSaveChanges = (editor_data) => {
    setShowCreate(false);
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setQuizQuestion("");
    setQuizAns("");

    const data = {
      topicId: selTopicDetails.topicId,
      quizType: quizType,
      quizData: [
        ...quiz,
        {
          optionA: optionA,
          optionB: optionB,
          optionC: optionC,
          optionD: optionD,
          correctOption: quizAns,
          questionId: new Date().getTime(),
          question: quizQuestion,
          questionOrder: "",
          questionCategory: "objective",
          questionMediaType: "",
          questionMedia: "",
        },
      ],
    };

    const data2 = {
      topicId: selTopicDetails.topicId,
      quizType: quizType,
      quizData: [
        ...quiz,
        {
          optionA: optionA,
          optionB: optionB,
          optionC: optionC,
          optionD: optionD,
          correctOption: quizAns,
          questionId: new Date().getTime(),
          question: quizQuestion,
          questionOrder: "",
          questionCategory: "objective",
          questionMediaType: "",
          questionMedia: "",
        },
      ],
    };

    //To create a quiz ---------------------------
    if (quizType === "quiz1") {
      createQuizContent(data)
        .then((element) => {
          if (element && element.status === 200) {
            const data = {
              ...quiz,
              usertype: usertype,
              trainingType: programtype,
              moduleid: selModuleDetails.moduleId,
              submoduleid: selSubModuleDetails.submoduleId,
              topicId: selTopicDetails.topicId,
              language: preferedlanguage,
              quizType: quizType,
            };

            if (quizType) {
              toast.success("Quiz has been successfully created !");
              getAllQuizes(data)
                .then((res) => {
                  setQuiz(res.data);
                })
                .catch((error) => {
                  console.error("The error is--------------->", error);
                  if (error.response.status === 500) {
                    toast.error("Internal server error.");
                  } else if (error.response.status === 504) {
                    toast.error("Server timeout. Please try again later.");
                  } else {
                    console.error("An unexpected error occurred:", error);
                    toast.error(
                      "An unexpected error occurred. Please try again later."
                    );
                  }
                });
            }
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    } else if (quizType === "quiz2") {
      createQuizContent(data2)
        .then((element) => {
          if (element && element.status === 200) {
            const data = {
              ...quiz,
              usertype: usertype,
              trainingType: programtype,
              moduleid: selModuleDetails.moduleId,
              submoduleid: selSubModuleDetails.submoduleId,
              topicId: selTopicDetails.topicId,
              language: preferedlanguage,
              quizType: quizType,
            };
            toast.success("Quiz has been successfully created !");
            if (quizType) {
              getAllQuizes(data)
                .then((res) => {
                  setQuiz(res.data);
                })
                .catch((error) => {
                  console.error("The error is--------------->", error);
                  if (error.response.status === 500) {
                    toast.error("Internal server error.");
                  } else if (error.response.status === 504) {
                    toast.error("Server timeout. Please try again later.");
                  } else {
                    console.error("An unexpected error occurred:", error);
                    toast.error(
                      "An unexpected error occurred. Please try again later."
                    );
                  }
                });
            }
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
    // }
  };

  const [updateData, setUpdateData] = useState({
    topicId: selTopicDetails.topicId,
    quizData: [
      {
        A: "",
        B: "",
        C: "",
        D: "",
        correctOption: "",
        question: "",
      },
    ],
  });

  const delete_quiz_button_click = (item, index) => {
    //console.log("eachsegment-------->", item.questionId);
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (item.questionMedia) {
          console.log("questionMedia deleted");
          deleteFileFromDB(item.questionMedia);
        }
        const qz = quiz.filter((x) => {
          return x.questionId !== item.questionId;
        });
        toast.success("Successfully removed the data");
        //console.log("qz--------->", qz);
        // setQuiz(qz);
        const data = {
          topicId: selTopicDetails.topicId,
          quizType: quizType,
          quizData: qz,
        };
        //console.log("data sent----->", data);
        api
          .put("updateMasterTchTrainingQuiz", data)
          .then((res) => {
            const dataa = {
              ...quiz,
              usertype: usertype,
              trainingType: programtype,
              moduleid: selModuleDetails.moduleId,
              submoduleid: selSubModuleDetails.submoduleId,
              topicId: selTopicDetails.topicId,
              language: preferedlanguage,
              quizType: quizType,
            };
            getAllQuizes(dataa)
              .then((res) => setQuiz(res.data))
              .catch((error) => {
                console.error("The error is--------------->", error);
                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
              });
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  //---------------------Delete all quizes---------------------
  const deleteAllQuizes = () => {
    if (
      preferedlanguage &&
      usertype &&
      programtype &&
      selModuleDetails &&
      selSubModuleDetails &&
      selTopicDetails &&
      quizType
    ) {
      Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this record!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      })
        .then((result) => {
          if (result.isConfirmed) {
            const data = {
              topicId: selTopicDetails.topicId,
              quizType: quizType,
            };
            deleteQuiz(data)
              .then((res) => {
                const dataa = {
                  topicId: selTopicDetails.topicId,
                  quizType: quizType,
                };
                getAllQuizes(dataa)
                  .then((res) => {
                    setQuiz(res.data);
                  })
                  .catch((error) => {
                    if (error.response.status === 500) {
                      toast.error("Internal server error.");
                    } else if (error.response.status === 504) {
                      toast.error("Server timeout. Please try again later.");
                    } else {
                      console.error("An unexpected error occurred:", error);
                      toast.error(
                        "An unexpected error occurred. Please try again later."
                      );
                    }
                    return false; // Prevent Swal from closing
                  });
              })
              .catch((error) => {
                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
                return false; // Prevent Swal from closing
              });
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    } else {
      toast.error("Please first select all the fields !!");
    }
  };

  //-------------------create quiz end -----------------------

  //console.log("quiz--------->", quiz);
  //console.log("quizType-------->", quizType);
  //console.log("topicId used------->", selTopicDetails.topicId);
  //console.log("Data-1--------->", quiz);

  // ---------------- navigate to skillset manager -------------

  //For updating the existing quiz(opens the modal)------------
  const update_quiz_button_click = (eachskill) => {
    setUpdateData({
      A: eachskill.optionA,
      B: eachskill.optionB,
      C: eachskill.optionC,
      D: eachskill.optionD,
      correctOption: eachskill.correctOption,
      question: eachskill.question,
      questionId: eachskill.questionId,
    });
    setShowUpdate(true);
  };

  //For updating the data in the modal-------------->
  const handleUpdateChanges = () => {
    const udData = quiz.map((item) => {
      if (item.questionId == updateData.questionId) {
        item.optionA = updateData.A;
        item.optionB = updateData.B;
        item.optionC = updateData.C;
        item.optionD = updateData.D;
        item.correctOption = updateData.correctOption;
        item.question = updateData.question;
        item.questionId = updateData.questionId;
        item.questionMediaType = updateData.questionMediaType;
        item.questionOrder = updateData.questionOrder;
        item.questionMedia = updateData.questionMedia;
      }
      return item;
    });
    const data = {
      topicId: selTopicDetails.topicId,
      quizType: quizType,
      quizData: udData,
    };
    api
      .put(`updateMasterTchTrainingQuiz`, data)
      .then(
        (response) => {
          if (response.status === 200) {
            const dataa = {
              topicId: selTopicDetails.topicId,
              quizType: quizType,
            };
            if (quizType) {
              getAllQuizes(dataa)
                .then((res) => {
                  toast.success("Changes made successfully");
                  setQuiz(res.data);
                })
                .catch((error) => {
                  console.error("The error is--------------->", error);
                  if (error.response.status === 500) {
                    toast.error("Internal server error.");
                  } else if (error.response.status === 504) {
                    toast.error("Server timeout. Please try again later.");
                  } else {
                    console.error("An unexpected error occurred:", error);
                    toast.error(
                      "An unexpected error occurred. Please try again later."
                    );
                  }
                });
            }
          }
        },
        (err) => {
          //console.log(err);
          toast.error("Enter a valid Quiz");
        }
      )
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
    setShowUpdate(false);
  };

  //--------Assignment handling------------------------
  const update_button_click = (data) => {
    handleVertMenuClose();
    if (Object.keys(data).length > 0) {
      const assignmentQuestion_old = data.assignmentQuestion;

      Swal.fire({
        title: "UPDATE ASSIGNMENT",
        input: "text",
        inputValue: assignmentQuestion_old,
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Update",
        showLoaderOnConfirm: true,
        preConfirm: async (input_value) => {
          if (
            input_value === undefined ||
            input_value === null ||
            input_value.length <= 0
          )
            toast.error("Enter a valid assignment");
          else {
            setLoading(true);
            const params1 = {
              assignmnentQuestionId: assignmentData[0]?.assignmentQuestionId,
              topicId: selTopicDetails.topicId,
              assignmnentQuestion: input_value,
            };
            updateassignmentquestion(params1)
              .then((res) => {
                setLoading(false);
                const params2 = {
                  topicId: selTopicDetails.topicId,
                };
                getAllData(params2)
                  .then((res) => {
                    setAssignmentData(res.data);
                  })
                  .catch((error) => {
                    console.error("The error is--------------->", error);
                    if (error.response.status === 500) {
                      toast.error("Internal server error.");
                    } else if (error.response.status === 504) {
                      toast.error("Server timeout. Please try again later.");
                    } else {
                      console.error("An unexpected error occurred:", error);
                      toast.error(
                        "An unexpected error occurred. Please try again later."
                      );
                    }
                  });
              })
              .catch((error) => {
                console.error("The error is--------------->", error);
                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
              });
          }
        },
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again later.",
      });
    }
  };

  //----------Assignment delete button------------------
  const delete_button_click = (data) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure, you want to remove this assignment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = {
          topicId: selTopicDetails.topicId,
        };
        deleteAssignmentData(data)
          .then((res) => {
            const params2 = {
              topicId: selTopicDetails.topicId,
            };
            getAllData(params2)
              .then((res) => {
                setAssignmentData(res.data);
              })
              .catch((error) => {
                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
                return false; // Prevent Swal from closing
              });
            setLoading(false);
            toast.success("Assignment deleted successfully");
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  //--------------Assignment Create Button With button click------
  const create_button_click = () => {
    if (assignmentData.length > 0) {
      // Case 1: There is at least one entry in displayData
      const firstEntry = assignmentData[0];
      if (
        firstEntry.assignmentQuestion &&
        firstEntry.assignmentQuestion.trim().length > 0
      ) {
        // Check if the assignmentQuestion property of the first entry has a valid value
        Swal.fire({
          icon: "error",
          title: "Oops...",
          html: "Cannot create a new assignment question. <br />There are multiple assignment questions found. <br />Kindly remove them to create a new one.",
        });
      } else {
        // The assignmentQuestion property of the first entry is empty or has no valid value
        promptForNewAssignment();
      }
    } else {
      // Case 2: There are no entries in displayData
      promptForNewAssignment();
    }
  };

  const promptForNewAssignment = async () => {
    const { value: input_value } = await Swal.fire({
      title: "CREATE A NEW ASSIGNMENT",
      input: "text",
      inputValue: "",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.trim().length === 0
        ) {
          toast.error("Enter a valid assignment");
          return false; // Prevent Swal from closing
        }

        const params1 = {
          assignmnentQuestionId: new Date().getTime().toString(),
          topicId: selTopicDetails.topicId,
          assignmnentQuestion: input_value.trim(), // Trim any leading/trailing spaces
        }; //assignmnentQuestion

        createAssignmentData(params1)
          .then((res) => {
            const data = { topicId: selTopicDetails.topicId };
            getAllData(data).then((res) => {
              setAssignmentData(res.data);
            });
          })
          .catch((error) => {
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
            return false; // Prevent Swal from closing
          });
      },
    });

    if (input_value) {
      // If input_value is truthy (i.e., assignment saved successfully), show success toast
      toast.success("Assignment saved successfully");
    }
  };

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [showUpdates, setShowUpdates] = useState(false);

  //-----------------Quiz Template (New)------------------------------
  const [showQuizDialog, setShowQuizDialog] = useState(false);
  const [action, setAction] = useState("");
  const [myParams, setMyParams] = useState(null);

  const quiz_on_close = () => setShowQuizDialog(false);

  const quiz_on_save = (quizdata) => {
    if (action === "save") save_quiz_data(quizdata);
    else if (action === "update") update_quiz_data(quizdata);
  };

  const quiz_on_open = (action, quizObject) => {
    if (
      preferedlanguage &&
      usertype &&
      selModuleDetails &&
      selSubModuleDetails &&
      programtype &&
      selTopicDetails
    ) {
      const param = { action, quizObject };
      setAction(action);
      setMyParams(param);
      if (
        preferedlanguage === undefined ||
        preferedlanguage === null ||
        preferedlanguage.trim().length <= 0
      )
        alert("Language is Missing");
      else if (
        usertype === undefined ||
        usertype === null ||
        usertype.trim().length <= 0
      )
        alert("Usertype is Missing");
      else if (
        selTopicDetails.topicId === undefined ||
        selTopicDetails.topicId === null ||
        selTopicDetails.topicId.trim().length <= 0
      )
        alert("Topic is Missing");
      else setShowQuizDialog(true);
    } else {
      toast.error("Please first select all the fields !");
    }
  };

  const save_quiz_data = (quizdata) => {
    const data = {
      topicId: selTopicDetails.topicId,
      quizType: quizType,
      quizData: [...quiz, quizdata], //
    };

    const data2 = {
      topicId: selTopicDetails.topicId,
      quizType: quizType,
      quizData: [...quiz, quizdata],
    };

    if (quizType === "quiz1") {
      createQuizContent(data)
        .then((element) => {
          if (element && element.status === 200) {
            const data = {
              ...quiz,
              usertype: usertype,
              trainingType: programtype,
              moduleid: selModuleDetails.moduleId,
              submoduleid: selSubModuleDetails.submoduleId,
              topicId: selTopicDetails.topicId,
              language: preferedlanguage,
              quizType: quizType,
            };

            if (quizType) {
              toast.success("Quiz has been successfully created !");
              getAllQuizes(data)
                .then((res) => {
                  setQuiz(res.data);
                  setShowQuizDialog(false);
                })
                .catch((error) => {
                  console.error("The error is--------------->", error);
                  if (error.response.status === 500) {
                    toast.error("Internal server error.");
                  } else if (error.response.status === 504) {
                    toast.error("Server timeout. Please try again later.");
                  } else {
                    console.error("An unexpected error occurred:", error);
                    toast.error(
                      "An unexpected error occurred. Please try again later."
                    );
                  }
                });
            }
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    } else if (quizType === "quiz2") {
      createQuizContent(data2)
        .then((element) => {
          if (element && element.status === 200) {
            const data = {
              ...quiz,
              usertype: usertype,
              trainingType: programtype,
              moduleid: selModuleDetails.moduleId,
              submoduleid: selSubModuleDetails.submoduleId,
              topicId: selTopicDetails.topicId,
              language: preferedlanguage,
              quizType: quizType,
            };
            toast.success("Quiz has been successfully created !");
            if (quizType) {
              getAllQuizes(data)
                .then((res) => {
                  setQuiz(res.data);
                  setShowQuizDialog(false);
                })
                .catch((error) => {
                  console.error("The error is--------------->", error);
                  if (error.response.status === 500) {
                    toast.error("Internal server error.");
                  } else if (error.response.status === 504) {
                    toast.error("Server timeout. Please try again later.");
                  } else {
                    console.error("An unexpected error occurred:", error);
                    toast.error(
                      "An unexpected error occurred. Please try again later."
                    );
                  }
                });
            }
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
  };

  const update_quiz_data = (quizdata) => {
    //console.log("quizdata---->", quizdata);
    const updateDataSet = quiz.map((item) => {
      if (item.questionId === quizdata.questionId) {
        return {
          ...item,
          ...quizdata,
        };
      }
      return item;
    });

    //console.log("quizdata sent to update body------------->", quizdata);

    const data = {
      topicId: selTopicDetails.topicId,
      quizType: quizType,
      quizData: updateDataSet,
    };

    setShowQuizDialog(false);
    //console.log("data--", data);
    api
      .put(`updateMasterTchTrainingQuiz`, data)
      .then(
        (response) => {
          setShowQuizDialog(false);
          const data = {
            topicId: selTopicDetails.topicId,
            quizType: quizType,
          };
          getAllQuizes(data)
            .then((res) => setQuiz(res.data))
            .catch((error) => {
              console.error("The error is--------------->", error);
              if (error.response.status === 500) {
                toast.error("Internal server error.");
              } else if (error.response.status === 504) {
                toast.error("Server timeout. Please try again later.");
              } else {
                console.error("An unexpected error occurred:", error);
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
              }
            });
          toast.success("Changes made successfully");
        },
        (err) => {
          //console.log(err);
          toast.error("Enter a valid Quiz");
        }
      )
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  useEffect(() => {
    const data = {
      language: preferedlanguage,
      usertype: "fellow",
    };
    getAllProgramTypes(data)
      .then((modules) => {
        setProgramData(modules.data);
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  }, []);

  function getYouTubeId(url) {
    let videoId = "";
    const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      videoId = match[2];
    }
    return videoId;
  }

  useEffect(() => {
    if (openEditor === true) {
      setContents([]);
    } else {
      if (selTopicDetails.topicId) {
        getAllContents({ topicId: selTopicDetails.topicId })
          .then((res) => {
            if (res.status === 200) {
              setContents(res.data);
            }
          })
          .catch((error) => console.error("The error---->", error));
      }
    }
  }, [openEditor]);

  const handleClose = () => {
    setShow(false);
    setReferenceData("");
    setLabel("");
  };

  const linkOnchange = (e) => {
    setReferenceData(e.target.value);
  };

  console.log("reference");

  const close_link_dialog = () => {
    // resetAll();
    // setShow(false);
    handleClose();
    setUpdateRef({
      title: "",
      link: "",
    });
  };

  const handleKeyPress = (event) => {
    event.preventDefault();
  };

  const handleSaveLink = async () => {
    // Check if the link is provided
    if (!referenceData || referenceData.trim() === "") {
      toast.error("Please provide a valid link before saving.");
      return;
    }
    const newReference = {
      id: new Date().getTime(),
      title: label,
      link: referenceData,
    };

    const data = {
      topicId: selTopicDetails?.topicId,
      referenceData: [...referenceArray, newReference],
    };

    console.log("data----------->", data);

    try {
      const createResponse = await createLink(data);

      if (createResponse.status === 200 || createResponse.status === 201) {
        toast.success("Link created successfully");
      } else {
        toast.warn("Unexpected response while creating link");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server error occurred while creating link");
        } else if (error.response.status === 504) {
          toast.error("Gateway timeout while creating link");
        } else {
          toast.error("Error while creating link");
        }
      }
    }

    try {
      const getResponse = await getLink(data);
      if (getResponse.status === 200) {
        // toast.success("Link retrieved successfully");
        setReferenceArray(getResponse?.data);
      } else if (getResponse.status === 204) {
        setReferenceArray([]);
        toast.info("No content available for the requested link");
      } else {
        toast.warn("Unexpected response while retrieving link");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server error occurred while retrieving link");
        } else if (error.response.status === 504) {
          toast.error("Gateway timeout while retrieving link");
        } else {
          toast.error("Error while retrieving link");
        }
      } else {
        toast.error("Network or other error occurred");
      }
    }
    setShow(false);
    setReferenceData("");
    setLabel("");
  };

  console.log("referenceArray-------------->", referenceArray);
  console.log("referenceDataArray------------------>", referenceDataArray);

  const [updateRef, setUpdateRef] = useState({
    title: "",
    link: "",
  });

  const handleEdit = (ref) => {
    setShowUpdate(true);
    setUpdateRef({
      _id: ref._id,
      title: ref.title,
      link: ref.link,
    });
  };

  const handleEditLink = async (ref) => {
    // Check if both title and link are valid
    if (
      !ref?.title ||
      ref?.title.trim() === "" ||
      !ref?.link ||
      ref?.link.trim() === ""
    ) {
      toast.error("Please provide both a valid title and link before saving.");
      return;
    }
    // Update the specific reference by creating a new updated object
    const updatedArray = referenceArray.map((item) =>
      item._id === ref._id
        ? { ...item, title: ref.title, link: ref.link }
        : item
    );

    // Prepare the referenceData array for the API call
    const referenceData = updatedArray.map((item) => ({
      title: item.title,
      link: item.link,
    }));

    // Prepare the data for API
    const data = {
      topicId: selTopicDetails?.topicId,
      referenceData: referenceData, // Pass the updated reference data as an array
    };
    console.log("updateLink", data);

    try {
      const createResponse = await updateLink(data); // Pass the data in the required format

      if (createResponse.status === 200 || createResponse.status === 204) {
        toast.success("Link updated successfully");
      } else {
        toast.warn("Unexpected response while updating link");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server error occurred while updating link");
        } else if (error.response.status === 504) {
          toast.error("Gateway timeout while updating link");
        } else {
          toast.error("Error while updating link");
        }
      }
    }

    // Fetch updated links after the update
    try {
      const getResponse = await getLink(data);
      if (getResponse.status === 200) {
        setReferenceArray(getResponse?.data);
      } else if (getResponse.status === 204) {
        setReferenceArray([]);
        toast.info("No content available for the requested link");
      } else {
        toast.warn("Unexpected response while retrieving link");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server error occurred while retrieving link");
        } else if (error.response.status === 504) {
          toast.error("Gateway timeout while retrieving link");
        } else {
          toast.error("Error while retrieving link");
        }
      } else {
        toast.error("Network or other error occurred");
      }
    }
    setShowUpdate(false);
    setReferenceData("");
    setLabel("");
  };

  const handleDelete = (refToDelete) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure, you want to remove this Link?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Filter out the object to be deleted from updateRef
        const updatedReferenceData = referenceArray.filter(
          (item) => item._id !== refToDelete._id
        );

        const data = {
          topicId: selTopicDetails?.topicId,
          referenceData: updatedReferenceData, // Pass the updated reference array
        };

        try {
          await updateLink(data); // Use the update API to save the new data without the deleted link
          toast.success("Link deleted successfully");
          setReferenceArray(updatedReferenceData);
        } catch (error) {
          handleError(error);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleError = (error) => {
    console.error("Error occurred:", error);
    if (error.response?.status === 500) {
      toast.error("Internal server error.");
    } else if (error.response?.status === 504) {
      toast.error("Server timeout. Please try again later.");
    } else {
      toast.error("An unexpected error occurred. Please try again later.");
    }
  };

  const getColorByIndex = (index) => {
    const colors = [
      "#ff9999", // Brighter red
      "#ffb380", // Brighter orange
      "#ffff99", // Brighter yellow
      "#90ee90", // Brighter green
      "#87cefa", // Brighter blue
      "#d8bfd8", // Brighter purple
      "#c6c6f9", // Brighter violet
    ];
    return colors[index % colors.length];
  };

  return (
    <>
      <div>
        <MuiHeader header="Pedagogy/ 21st/ Tech Section" />
        <Container maxWidth="lg">
          <Grid container spacing={2} alignItems="center">
            {/* 1st section - dropdowns */}
            <Grid item>
              <FormControl
                sx={{ m: 1 }}
                style={{ width: "130px", marginLeft: "-64px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Language</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={preferedlanguage}
                  label="Language" //
                  onChange={preflanguage_select_onchange}
                >
                  <MenuItem value="">None</MenuItem>
                  {language_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl
                sx={{ m: 1 }}
                style={{ width: "130px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Usertype</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={usertype}
                  label="Usertype"
                  onChange={usertype_select_onchange}
                >
                  {/* <MenuItem value="">None</MenuItem> */}
                  {usertype_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl
                sx={{ m: 1 }}
                style={{ width: "150px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Trainingtype</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={programtype}
                  label="Trainingtype"
                  onChange={program_select_onchange}
                >
                  <MenuItem value="">None</MenuItem>
                  {usertype
                    ? trainingTypeArray.map((option) => (
                        <MenuItem
                          key={option.trainingType}
                          value={option.trainingType}
                        >
                          {option.trainingName}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl
                sx={{ m: 1 }}
                style={{ width: "130px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Module</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={selModuleDetails}
                  label="Module"
                  onChange={module_select_onchange}
                >
                  <MenuItem value="">None</MenuItem>
                  {usertype && programtype && Array.isArray(modules)
                    ? modules.map((option) => (
                        <MenuItem key={option.moduleId} value={option.moduleId}>
                          {option.moduleName}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl
                sx={{ m: 1 }}
                style={{ width: "140px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Sub-Module</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={selSubModuleDetails}
                  label="Submodule"
                  onChange={submodule_select_onchange} //
                >
                  <MenuItem value="">None</MenuItem>
                  {usertype &&
                  usertype != "" &&
                  programtype &&
                  Array.isArray(subModules)
                    ? subModules.map((option) => (
                        <MenuItem
                          key={option.submoduleId}
                          value={option.submoduleId}
                        >
                          {option.submoduleName}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl
                sx={{ m: 1 }}
                style={{ width: "130px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Topic</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={selTopicDetails} //
                  label="Topic"
                  onChange={topic_select_onchange}
                >
                  <MenuItem value="">None</MenuItem>
                  {usertype &&
                  usertype != "" &&
                  programtype &&
                  Array.isArray(topics)
                    ? topics.map((option) => (
                        <MenuItem key={option.topicId} value={option}>
                          {option.topicName}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <Button
                onClick={() => navigate_to("/pedagogy-modules")} //
                variant="outlined"
                sx={{ m: 1, minWidth: 120, marginTop: 0, marginLeft: "1000px" }}
                size="small"
              >
                Create Modules
              </Button>
            </Grid>
            {/* 2nd section - content section*/}
            {/* <Grid item xs={12} sm={7}> */}
            {preferedlanguage &&
            usertype &&
            programtype &&
            selModuleDetails &&
            selSubModuleDetails ? (
              <div>
                <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
                  <AppBar
                    position="static"
                    style={{
                      background: "#dedede",
                      color: "black",
                      width: "1280px",
                      marginLeft: "-50px",
                    }}
                  >
                    <Tabs
                      value={tabIndex}
                      onChange={onTabChange}
                      indicatorColor="primary"
                      textColor="inherit"
                      variant="fullWidth"
                      aria-label="full width tabs example"
                    >
                      <Tab label="Content" {...a11yProps(0)} />
                      <Tab label="Quiz" {...a11yProps(1)} />
                      <Tab label="Assignment" {...a11yProps(2)} />
                      <Tab label="Link" {...a11yProps(3)} />
                    </Tabs>
                  </AppBar>

                  <div
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={tabIndex}
                    onChangeIndex={onTabIndexChange}
                  >
                    <TabPanel value={tabIndex} index={0} dir={theme.direction}>
                      <div>
                        <div className="outer-preview">
                          <div className="inner-preview">
                            {contents.length > 0 ? (
                              contents.map((object, index) => (
                                <div key={index}>
                                  <div>
                                    {object.type === "text" && (
                                      <>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: object.label,
                                          }}
                                          style={{ wordWrap: "break-word" }}
                                        ></div>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: object.value,
                                          }}
                                          style={{ wordWrap: "break-word" }}
                                        ></div>
                                      </>
                                    )}

                                    {object.type === "rearrangement" && (
                                      <>
                                        {object.type === "rearrangement" && (
                                          <>
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: object.label,
                                              }}
                                              style={{ wordWrap: "break-word" }}
                                            ></div>
                                            <div>
                                              {object.value?.map(
                                                (wordItem, index) => (
                                                  <div
                                                    key={index}
                                                    style={{
                                                      display: "inline-block",
                                                      margin: "10px",
                                                      padding: "5px",
                                                      border: "1px solid #000",
                                                      borderRadius: "5px",
                                                      minWidth: "50px",
                                                      height: "25px",
                                                      backgroundColor:
                                                        getColorByIndex(index),
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        marginTop: "3%",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      {wordItem.wordValue}
                                                    </p>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}

                                    {object.type === "puzzle" && (
                                      <>
                                        {object.type === "puzzle" && (
                                          <>
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: object.label,
                                              }}
                                              style={{ wordWrap: "break-word" }}
                                            ></div>
                                            <div>
                                              {object.value?.map(
                                                (wordItem, index) => (
                                                  <div
                                                    key={index}
                                                    style={{
                                                      display: "inline-block",
                                                      margin: "10px",
                                                      padding: "5px",
                                                      border: "1px solid #000",
                                                      borderRadius: "5px",
                                                      minWidth: "50px",
                                                      height: "25px",
                                                      backgroundColor:
                                                        getColorByIndex(index),
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        marginTop: "3%",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      {wordItem.wordValue}
                                                    </p>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}

                                    {object.type === "image" && (
                                      <>
                                        <div>
                                          <div>{object.label}</div>
                                          <img
                                            src={
                                              object.value.startsWith("https")
                                                ? object.value
                                                : `https://tzedustorage.blob.core.windows.net/tzeducontainer/${object.value}`
                                            }
                                            width="90%"
                                            alt=""
                                          />
                                        </div>
                                      </>
                                    )}

                                    {object.type === "hotspot" && (
                                      <>
                                        <div>
                                          <div>{object.label}</div>
                                          <img
                                            src={
                                              object.thumbnail.startsWith(
                                                "https"
                                              )
                                                ? object.thumbnail
                                                : `https://storage.googleapis.com/tz-bucket-0/${object.thumbnail}`
                                            }
                                            width="90%"
                                            alt=""
                                          />
                                        </div>
                                      </>
                                    )}
                                    {object.type === "slider" && (
                                      <Carousel
                                        style={{
                                          display: "block",
                                          marginTop: "10px",
                                        }}
                                      >
                                        {object?.value?.map((url, index) => (
                                          <Paper
                                            key={index}
                                            style={{
                                              width: "100%",
                                              padding: "5px",
                                            }}
                                          >
                                            <img
                                              src={url}
                                              width="100%"
                                              alt=""
                                              style={{
                                                width: "100%",
                                                height: "auto",
                                                display: "block",
                                              }}
                                            />
                                          </Paper>
                                        ))}
                                      </Carousel>
                                    )}

                                    {object.type === "audio" && (
                                      <>
                                        <div>
                                          <div>{object.label}</div>
                                          <audio
                                            controls
                                            style={{ width: "90%" }}
                                          >
                                            <source
                                              src={
                                                object.value.startsWith("https")
                                                  ? object.value
                                                  : `https://storage.googleapis.com/tz-bucket-0/${object.value}`
                                              }
                                            />
                                          </audio>
                                        </div>
                                      </>
                                    )}

                                    {object.type === "audio" ||
                                      (object.type === "text-audio" && (
                                        <>
                                          <div>
                                            <div>{object.label}</div>
                                            <audio
                                              controls
                                              style={{ width: "90%" }}
                                            >
                                              <source
                                                src={
                                                  object.value.startsWith(
                                                    "https"
                                                  )
                                                    ? object.value
                                                    : `https://storage.googleapis.com/tz-bucket-0/${object.value}`
                                                }
                                              />
                                            </audio>
                                          </div>
                                        </>
                                      ))}

                                    {object.type === "video" && (
                                      <div>
                                        <div>{object.label}</div>
                                        {!isVideoPlaying ? (
                                          <div
                                            onClick={handlePlayVideo}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <img
                                              src={
                                                object.thumbnail.startsWith(
                                                  "https"
                                                )
                                                  ? object.thumbnail
                                                  : `https://storage.googleapis.com/tz-bucket-0/${object.thumbnail}`
                                              }
                                              width="100%"
                                              alt=""
                                            />
                                          </div>
                                        ) : (
                                          <video controls width="100%" autoPlay>
                                            <source
                                              src={
                                                object.value.startsWith("https")
                                                  ? object.value
                                                  : `https://storage.googleapis.com/tz-bucket-0/${object.value}`
                                              }
                                            />
                                          </video>
                                        )}
                                      </div>
                                    )}

                                    {object.type === "youtube" && (
                                      <>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: object.label,
                                          }}
                                          style={{ wordWrap: "break-word" }}
                                        ></div>
                                        <div>
                                          <iframe
                                            title="YouTube Video"
                                            width="320"
                                            height="195"
                                            src={`https://www.youtube.com/embed/${object.value}`}
                                            frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen
                                          ></iframe>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <h4>No content available</h4>
                            )}
                          </div>
                          <div style={{ marginLeft: "300px" }}>
                            <ButtonGroup
                              orientation="vertical"
                              aria-label="vertical outlined button group"
                            >
                              <Button
                                color="primary"
                                onClick={create_content_button_click}
                                disabled={disable_content_button}
                              >
                                <AddCircleOutlineIcon />
                                Create Content
                              </Button>
                              <Button
                                color="primary"
                                onClick={update_content_button_click}
                                disabled={!contents.length}
                              >
                                <DriveFileRenameOutlineIcon />
                                Update Content
                              </Button>
                              <Button
                                color="error"
                                onClick={delete_content_button_click}
                                disabled={!contents.length}
                              >
                                <HighlightOffIcon />
                                Delete Content
                              </Button>
                            </ButtonGroup>
                          </div>
                        </div>
                      </div>

                      {/* Content part end */}
                    </TabPanel>
                    <TabPanel value={tabIndex} index={1} dir={theme.direction}>
                      {preferedlanguage &&
                      usertype &&
                      programtype &&
                      selModuleDetails &&
                      selSubModuleDetails &&
                      selTopicDetails ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControl
                            sx={{ m: 1 }}
                            style={{ width: "120px" }}
                            size="small"
                          >
                            <InputLabel id="demo-select-small">
                              Quiz Type
                            </InputLabel>
                            <Select
                              labelId="demo-select-small"
                              id="demo-select-small"
                              value={quizType}
                              label="Language" //
                              onChange={quizType_onChange}
                            >
                              <MenuItem value="">None</MenuItem>
                              {quizType_select_option_list.map((option) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.text}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          {preferedlanguage &&
                          usertype &&
                          programtype &&
                          selModuleDetails &&
                          selSubModuleDetails &&
                          selTopicDetails &&
                          quizType ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {quizType ? (
                                <Button
                                  onClick={() => quiz_on_open("save", null)}
                                  variant="contained"
                                  sx={{ marginTop: 3, float: "left" }}
                                >
                                  Create Quiz
                                  <AddIcon />
                                </Button>
                              ) : null}
                              {quiz.length > 0 ? (
                                <Button
                                  variant="contained"
                                  onClick={deleteAllQuizes}
                                  style={{ marginTop: "20px" }}
                                >
                                  Delete All Quizes
                                </Button>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                      ) : null}

                      {preferedlanguage &&
                      usertype &&
                      programtype &&
                      selModuleDetails &&
                      selSubModuleDetails &&
                      selTopicDetails &&
                      quizType &&
                      quiz &&
                      quiz.length > 0 ? (
                        quiz.map((item, index) => (
                          <div>
                            <table
                              style={{
                                border: "2px solid blue",
                                width: "600px",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      width: "600px",
                                      textAlign: "left",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {index + 1}.{item.question}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {item.instructions ? (
                                    <td>
                                      <b>Instruction: </b>
                                      {item.instructions}
                                    </td>
                                  ) : null}
                                </tr>
                                <tr>
                                  {item.optionA ? (
                                    <td>A:{item.optionA}</td>
                                  ) : null}
                                  {item.optionB ? (
                                    <td>B:{item.optionB}</td>
                                  ) : null}
                                  <td>
                                    <Button
                                      variant="contained"
                                      onClick={() =>
                                        quiz_on_open("update", item)
                                      }
                                    >
                                      Update
                                    </Button>{" "}
                                  </td>
                                  <td>
                                    <Button
                                      variant="contained"
                                      onClick={() =>
                                        delete_quiz_button_click(item)
                                      }
                                    >
                                      Delete
                                    </Button>
                                  </td>
                                </tr>
                                <tr>
                                  {item.optionC ? (
                                    <td>C:{item.optionC}</td>
                                  ) : null}
                                  {item.optionD ? (
                                    <td>D:{item.optionD}</td>
                                  ) : null}
                                </tr>
                                {item.correctOption &&
                                item.correctOption.length > 0 ? (
                                  <tr>
                                    <td>
                                      <b>Answer-</b>
                                      {item.correctOption}
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        ))
                      ) : !quizType ? null : (
                        <h4>No Quiz Available</h4>
                      )}
                    </TabPanel>
                    <TabPanel value={tabIndex} index={2} dir={theme.direction}>
                      {preferedlanguage &&
                      usertype &&
                      selModuleDetails &&
                      selSubModuleDetails &&
                      selTopicDetails ? (
                        <Button
                          onClick={create_button_click}
                          variant="outlined"
                          sx={{ m: 1, minWidth: 120, marginTop: 0 }} //
                          size="small"
                        >
                          Create Assignment
                        </Button>
                      ) : null}
                      <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={5}>
                          {assignmentData.length > 0 ? (
                            assignmentData.map((data, index) => {
                              if (
                                data.assignmentQuestion &&
                                data.assignmentQuestion.length > 0
                              )
                                return (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={isSmallScreen ? 12 : 6}
                                    md={4}
                                    key={index}
                                  >
                                    <Card sx={{ width: "340px" }}>
                                      <CardHeader
                                        avatar={
                                          <Avatar sx={{ bgcolor: indigo[900] }}>
                                            <TaskIcon />
                                          </Avatar>
                                        }
                                        action={
                                          <>
                                            <IconButton
                                              id={index + 1.1}
                                              onClick={(e) =>
                                                handleVertMenuClick(e, data)
                                              }
                                              aria-controls={
                                                openVertMenu
                                                  ? { index }
                                                  : undefined
                                              }
                                              aria-expanded={
                                                openVertMenu
                                                  ? "true"
                                                  : undefined
                                              }
                                              aria-haspopup="true"
                                            >
                                              <MoreVertIcon />
                                            </IconButton>
                                          </>
                                        }
                                        title={
                                          <div
                                            style={{
                                              cursor: "pointer",
                                              wordBreak: "break-all",
                                            }}
                                          >
                                            {data.assignmentQuestion}
                                          </div>
                                        }
                                      />
                                    </Card>
                                  </Grid>
                                );
                              else return "";
                            })
                          ) : (
                            <h4
                              style={{
                                marginLeft: "100px",
                                marginTop: "50px",
                              }}
                            >
                              No data available
                            </h4>
                          )}

                          <Menu
                            anchorEl={anchorEl}
                            open={openVertMenu}
                            onClose={handleVertMenuClose}
                            MenuListProps={{
                              "aria-labelledby": "vert-button",
                            }}
                            PaperProps={{
                              style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: "20ch",
                              },
                            }}
                          >
                            <MenuItem
                              onClick={() => update_button_click(selectedData)}
                            >
                              Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() => delete_button_click(selectedData)}
                            >
                              Delete
                            </MenuItem>
                          </Menu>
                        </Grid>
                      </Box>
                    </TabPanel>
                    <TabPanel value={tabIndex} index={3} dir={theme.direction}>
                      <Button
                        variant="outlined"
                        sx={{ m: 1, minWidth: 120, marginTop: 0 }}
                        size="small"
                        onClick={handleShow}
                      >
                        Create Link ➕
                      </Button>

                      {/* Mapping over the reference array */}
                      {referenceArray.map((ref, index) => (
                        <div
                          key={ref._id}
                          style={{
                            marginTop: "10px",
                            padding: "10px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "5px",
                            backgroundColor: "#f9f9f9",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <Typography
                              variant="body2"
                              component="p"
                              sx={{ fontWeight: "bold" }}
                            >
                              {index + 1}. Reference: {ref.title}
                            </Typography>
                            <Typography
                              variant="body2"
                              component="a"
                              href={ref.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                color: "#1a0dab",
                                textDecoration: "underline",
                                cursor: "pointer",
                                "&:hover": {
                                  color: "#551a8b",
                                  textDecoration: "none",
                                },
                              }}
                            >
                              {ref.link}
                            </Typography>
                          </div>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => handleEdit(ref)}
                              sx={{ textTransform: "none" }}
                            >
                              Edit Link
                            </Button>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              onClick={() => handleDelete(ref)}
                              sx={{ textTransform: "none" }}
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      ))}
                    </TabPanel>
                  </div>
                </Box>
              </div>
            ) : null}
            {/* </Grid> */}
            {/**----------------Save Modal--------------- */}
            <Modal
              open={show}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div>
                  <div>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <div>
                          <div className="quiz-parent-segment-title">
                            Add Label
                          </div>
                          <div>
                            <TextField
                              id="add-question"
                              label="Add Label"
                              variant="outlined"
                              multiline
                              rows={3}
                              style={{ width: "470px" }}
                              size="small"
                              value={label}
                              onChange={(e) => setLabel(e.target.value)}
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <div>
                          <div className="quiz-parent-segment-title">
                            Add Link
                          </div>
                          <div>
                            <TextField
                              id="add-referenceData"
                              label="Add Link"
                              variant="outlined"
                              type="url"
                              style={{ width: "470px" }}
                              size="small"
                              value={referenceData}
                              onChange={linkOnchange}
                              // onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
                <div style={{ marginBottom: "100px" }}>
                  <Button
                    variant="outlined"
                    style={{ marginLeft: 12 }}
                    onClick={close_link_dialog}
                  >
                    Close
                  </Button>
                  {loadingSave ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "right",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <Button variant="contained" onClick={handleSaveLink}>
                      Save
                    </Button>
                  )}
                </div>
              </Box>
            </Modal>

            {/**----------------Update Modal--------------- */}
            <Modal
              open={showUpdate}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <div className="quiz-parent-segment-title">
                        Add Question
                      </div>
                      <TextField
                        id="add-question"
                        label="Add Question"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={updateRef?.title}
                        onChange={(e) =>
                          setUpdateRef({
                            ...updateRef,
                            title: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <div className="quiz-parent-segment-title">Add Link</div>
                      <TextField
                        id="add-link"
                        label="Add Link"
                        variant="outlined"
                        style={{ width: "470px" }}
                        size="small"
                        value={updateRef?.link}
                        onChange={(e) =>
                          setUpdateRef({
                            ...updateRef,
                            link: e.target.value,
                          })
                        }
                        // onKeyPress={handleKeyPress}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div style={{ marginBottom: "100px" }}>
                  <Button
                    variant="outlined"
                    style={{ marginLeft: 12 }}
                    onClick={handleCloseUpdate}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleEditLink(updateRef)} // Pass the updated ref when clicking update
                  >
                    Update
                  </Button>
                </div>
              </Box>
            </Modal>

            {/* 3rd section - options */}
            <Grid item xs={12} sm={2}>
              {/* Your menu button with multiple options goes here */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="left"
              ></Box>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Quiz
        open={showQuizDialog}
        params={myParams}
        onSubmit={quiz_on_save}
        onClose={quiz_on_close}
      />

      <MuiLoader open={loading} />

      <TemplateMaster
        open={openEditor}
        params={params}
        onClose={handleCloseEditor}
        contents={contents}
        setContents={setContents}
      />

      <ToastContainer />
    </>
  );
}

export default Pedagogy;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
